import { createContext, useContext } from 'react';
import { Config } from './types';

export const ConfigContext = createContext<Config | null>(null);

export const useConfig = () => {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return config;
};
